import { BlockType } from '../../types/index.js';
import { CardFooterBlock as Component } from './Block.js';
export const RegisteredCardFooterBlock = (_intl) => ({
    recommendedName: 'Card.Footer',
    Component,
    config: {
        type: BlockType.BuildingBlock,
        defaultProps: {
            withBorder: true,
        },
    },
});
//# sourceMappingURL=registered.js.map